<template>
    <div>
        <gateway-filter :action="filterAction" ></gateway-filter>
        <kt-datatable  v-bind="datatableProps" ref="datatable"></kt-datatable>
    </div>
</template>

<script>
import columns from './../datatable/columns'
import {ApiUrl, StarShopApiUrl} from '@/common/api.service'
import { AuthorizationHeader } from '@/common/jwt.service'
import actionsColumn from './actions-column'
import gatewayFilter from './gateway-filter'

export default {

    components: {
        'gateway-filter': gatewayFilter,
    },
    data() {
        return {
            query: {}
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "gateway_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: this.$route.path === '/starshop-gateways' ? StarShopApiUrl.path('gateway/admin/get') : ApiUrl.path('gateway/admin/get'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function(res) {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {
                },
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actionsColumn
            }
        },
    },
    methods: {
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        }
    }
}
</script>

<style>

</style>